import styled from "styled-components";
import {Box, Grid} from "@mui/material";
import ContentTitle, {TitleBarButton} from "./ContentTitle";
import LabeledValue from "./LabeledValue";
import React from "react";
import LabeledSection from "./LabeledSection";
import {Colors} from "../Colors";

const ContentSection = styled(Box)`
    padding: 14px;
`;

const GridSection = styled(Grid)`
    & > .MuiGrid-item {
        flex-grow: 1;
        margin: 0 24px 24px 0;
    }
`;

interface ContentProps {
    columns?: number;
    children?: React.ReactNode | React.ReactNode[];
    dataTest?: string;
}

const Content = ({columns = 1, children, dataTest = "content"}: ContentProps) => {
    const getContent = () => {
        return columns ? (
            <GridSection container xs={2} sm={6} md={6} lg={6} columns={columns}>
                {children}
            </GridSection>
        ) : (
            children
        );
    };
    return <ContentSection data-test={dataTest}>{getContent()}</ContentSection>;
};

const StyledPage = styled(Box)`
    background: ${Colors.CONTENT_BACKGROUND};
`;

const Page = ({children, dataTest = "page"}: ContentProps) => {
    return <StyledPage data-test={dataTest}>{children}</StyledPage>;
};

export {ContentTitle, Content};
export {LabeledValue, LabeledSection};
export type {TitleBarButton};
export default Page;
